/**
 * 휴대폰 번호 포매팅 (010-0000-0000)
 */
export const formatPhoneNumber = (value: string) => {
  // 숫자만 남기기
  const digits = value.replace(/\D/g, '');
  
  // 길이에 따른 하이픈 삽입
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 7) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
  }
};

/**
 * 사업자 등록 번호 포매팅 (000-00-00000)
 */
export const formatBusinessNumber = (value: string) => {
  // 숫자만 남기기
  const digits = value.replace(/\D/g, '');
  
  // 길이에 따른 하이픈 삽입 (XXX-XX-XXXXX)
  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 5) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else {
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 10)}`;
  }
};
